import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" className="mb-6" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1 text-sm text-muted-foreground">
      {items.map((item, i) => {
        const last = i === items.length - 1;
        return (
          <li key={i} className="flex items-center gap-1">
            {item.to && !last ? (
              <Link to={item.to} className="hover:text-primary">{item.label}</Link>
            ) : (
              <span className={last ? "font-medium text-foreground" : ""} aria-current={last ? "page" : undefined}>
                {item.label}
              </span>
            )}
            {!last && <ChevronRight className="h-3.5 w-3.5" />}
          </li>
        );
      })}
    </ol>
  </nav>
);
